export default {
  products: state => state.products,
  productCategories: state => state.productCategories,
  customProductCategories: state => state.customProductCategories,
  productCompaneis: state => state.productCompaneis,
  companyWithProducts: state => state.companyWithProducts,
};
